import { Tooltip } from 'bootstrap';

document.addEventListener("DOMContentLoaded", () => {
	const checkPage = document.querySelector(".requisite-row");
	const buttonCopy = document.querySelectorAll(".button-copy");
	if (checkPage) {
		buttonCopy.forEach(button => {
			let copyTooltip = new Tooltip(button);
			button.addEventListener('click', (e) => {
				let currentButton = e.currentTarget;

				// saving text to clipboard

				const { text } = e.currentTarget.dataset;
				window.navigator.clipboard.writeText(text);

				// change title

				copyTooltip.hide();
				currentButton.title = 'Скопировано';
				copyTooltip = new Tooltip(button);
				copyTooltip.show();

				// restore init title

				currentButton.addEventListener('hide.bs.tooltip', function () {
					currentButton.title = 'Копировать';
					copyTooltip = new Tooltip(button);
				})
			})
		})
	}
})
